module.exports = __webpack_public_path__ + "static/img/userbg1.538203da.png";